import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: "[roof-type-1]",
    templateUrl: "./roof-type-1.component.html",
    styleUrl: "./roof-type-1.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RoofType1Component {
}
